<div>
  <app-header></app-header>
  <div class="layout-main">
    <router-outlet></router-outlet>
  </div>
</div>